/** Lien catalogue / externe pour campagnes & événements CMS (schéma API partagé). */
export function resolveMarketingHref(item) {
  if (!item?.target_value) return "/catalogue";
  const t = item.target_type || "url";
  const v = String(item.target_value).trim();
  if (!v) return "/catalogue";
  if (t === "category") return `/catalogue/${encodeURIComponent(v)}`;
  if (t === "search") return `/catalogue?q=${encodeURIComponent(v)}`;
  if (t === "landing") return v.startsWith("/") ? v : `/${v}`;
  return v;
}

/** CTA secondaire campagne / événement V2. */
export function resolveSecondaryMarketingHref(item) {
  if (!item?.cta_secondary_label?.trim()) return "";
  const t = item.cta_secondary_target_type || "url";
  const v = String(item.cta_secondary_target_value || "").trim();
  if (!v) return "";
  if (t === "category") return `/catalogue/${encodeURIComponent(v)}`;
  if (t === "search") return `/catalogue?q=${encodeURIComponent(v)}`;
  if (t === "landing") return v.startsWith("/") ? v : `/${v}`;
  return v;
}

export function formatIsoDateShort(iso) {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleDateString("fr-FR", { day: "numeric", month: "short", year: "numeric" });
  } catch {
    return "";
  }
}

/** Lien principal pour un événement éditorial (inscription / infos), hors cible catalogue. */
export function resolveEditorialEventHref(item) {
  const reg = String(item?.registration_link || "").trim();
  if (reg) {
    if (reg.startsWith("http")) return reg;
    return reg.startsWith("/") ? reg : `/${reg}`;
  }
  const info = String(item?.info_link || "").trim();
  if (info) {
    if (info.startsWith("http")) return info;
    return info.startsWith("/") ? info : `/${info}`;
  }
  return resolveMarketingHref(item);
}

export function contentEventDateLine(ev) {
  const start = ev.event_starts_at || ev.start_date;
  const end = ev.event_ends_at || ev.end_date;
  const a = formatIsoDateShort(start);
  const b = formatIsoDateShort(end);
  if (a && b && a !== b) return `${a} — ${b}`;
  return a || b || "";
}
